module.exports = __webpack_public_path__ + "static/media/Testimonial_Home_Page_Img.fb743f87.png";